module.exports = __webpack_public_path__ + "img/loading.a6178f44.gif";